import script from "./roster.vue?vue&type=script&lang=js"
export * from "./roster.vue?vue&type=script&lang=js"

import "./roster.vue?vue&type=style&index=0&id=9deef0f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9deef0f2"]])

export default __exports__